"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.chainToLabel = exports.ChainLabel = void 0;
var react_1 = __importDefault(require("react"));
var TokenLabel_1 = require("./TokenLabel");
var BSC = function (_a) {
    var className = _a.className;
    return (react_1.default.createElement("svg", { viewBox: "0 0 20 25", xmlns: "http://www.w3.org/2000/svg", className: className },
        react_1.default.createElement("path", { d: "M10 0.94165L3.99957 4.5999L6.33164 5.95136L10.3428\n            3.64456L14.3539 5.95136L16.686 4.5999L10.3428 0.94165ZM14.3539 7.86204L16.686 9.2135V11.9164L12.6748 14.2232V18.8368L10.3428 20.1883L8.01072 18.8368V14.2232L3.99957 11.9164V9.2135L6.33164 7.86204L10.3428 10.1688L14.3539\n            7.86204ZM16.686 13.8271V16.53L14.3539 17.8815V15.1785L16.686 13.8271ZM14.3306 19.7921L18.3418 17.4853V12.8717L20.6738 11.5203V18.8368L14.3306 22.495V19.7921ZM18.3418\n            8.25815L16.0097 6.9067L18.3418 5.55524L20.6738 6.9067V9.60961L18.3418 10.9611V8.25815ZM8.01072 23.4737V20.7708L10.3428 22.1222L12.6748 20.7708V23.4737L10.3428\n            24.8251L8.01072 23.4737ZM6.33164 17.8815L3.99957 16.53V13.8271L6.33164 15.1785V17.8815ZM10.3428 8.25815L8.01072 6.9067L10.3428 5.55524L12.6748 6.9067L10.3428 8.25815ZM4.67585\n            6.9067L2.34378 8.25815V10.9611L0.0117188 9.60961V6.9067L2.34378 5.55524L4.67585 6.9067ZM0.0117188 11.5203L2.34378 12.8717V17.4853L6.35493 19.7921V22.495L0.0117188 18.8368V11.5203ZM124.882\n              19.5306H184.023V6.43549Z", fill: "#F0B90B" })));
};
exports.ChainLabel = { BSC: BSC };
exports.chainToLabel = {
    BSC: BSC,
    BSC_TEST: BSC,
    BASE: TokenLabel_1.TokenLabel.BASE,
    ETH: TokenLabel_1.TokenLabel.ETH,
    ETH_ROPSTEN: TokenLabel_1.TokenLabel.ETH,
    POLY: TokenLabel_1.TokenLabel.POLY,
    SOL: TokenLabel_1.TokenLabel.SOL,
    AVAX: TokenLabel_1.TokenLabel.AVAX,
    TERRA: TokenLabel_1.TokenLabel.TERRA,
    FTM: TokenLabel_1.TokenLabel.FTM,
    SUI: TokenLabel_1.TokenLabel.SUI,
    ZKSYNC: TokenLabel_1.TokenLabel.ETH,
};
